import React, { Component } from 'react';
import { observer, inject} from 'mobx-react';
import { LargeButton, ButtonType } from '@checkmarx/cx-ui';

@inject('translationsStore', 'forgotPasswordStore') @observer
export default class ForgotPasswordEmailSent extends Component {

    state = {
        goToLoginPageClicked: false
    };

    handleLoginClick = (e) => {

        this.setState({
            goToLoginPageClicked: true
        });
    
        window.location.href = './';
    }

    render() {       

        return(
            <div>
                <div className='general-form-wrapper forgot-password'>                   

                    <div className='welcome-message-wrapper'>
                        <span>
                            { this.props.translationsStore.translate('FORGOT_PASSWORD_EMAIL_SENT') 
                            + ' ' +
                             this.props.forgotPasswordStore.values.userName 
                            + '.' }
                        </span>
                    </div>                 
                    <LargeButton
                        id='btnResetPasswordCompleteSubmit'
                        dataCy='reset-password-complete-button'
                        onClick={this.handleLoginClick}
                        text={this.props.translationsStore.translate('GO_TO_LOGIN_PAGE')}
                        inProgress={this.state.goToLoginPageClicked}
                        style={{marginTop: '20px'}}
                    />
                </div> 
            </div>
        );
    }
}